import React, { FC } from 'react';
import translate from '@translate';
import ConfirmDialog from 'src/components/ConfirmDialog';
import { logoutAfterPasswordChange } from 'src/utils/passwordChangedLogout';

/** Shown after a successful password change; confirming logs the user out locally. */
const PasswordChangedDialog: FC = () => (
    <ConfirmDialog
        title={translate('changePassword.changedDialogTitle')}
        content={translate('changePassword.changedDialogText')}
        action={logoutAfterPasswordChange}
        onClose={() => {}}
        hideCancel
        dataTestId="password-changed-dialog"
    />
);

export default PasswordChangedDialog;
